import "./App.css";
import Navbar from "./components/Navbar";
import Quiz from "./components/Quiz";

function App() {
  return (
    <div className="App">
      <Navbar />
      <Quiz />
    </div>
  );
}

export default App;
